import {
  Button,
  Checkbox,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
} from "antd";
import { Notification } from "components/Notification/Noti";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  createToken,
  generateToken,
  getDomains,
} from "redux/slices/tokenManagement";
import styled from "styled-components";

const DrawerAddToken = ({ open, setOpen }) => {
  const [roles, setRoles] = useState([]);
  const { t } = useTranslation();
  const onClose = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  const { token, domains } = useSelector(
    (state) => state.tokenManagementReducer
  );

  const { userDetail } = useSelector((state) => state.userReducer);

  const [form] = Form.useForm();
  useEffect(() => {
    if (open) {
      dispatch(generateToken());
      dispatch(getDomains());
    }
  }, [open, dispatch]);

  useEffect(() => {
    if (token) {
      form.setFieldValue("token", token);
    }
  }, [token, form]);

  useEffect(() => {
    let tempRoles = [];
    domains.domain.forEach((item, idx) => {
      let rolesItem = {
        domain: item,
        permissions: [],
      };
      tempRoles.push(rolesItem);
    });
    setRoles(tempRoles);
  }, [domains]);

  const handleRefreshToken = () => {
    dispatch(generateToken(true));
  };

  const onFinish = (values) => {
    console.log(values.expired_date);
    dispatch(
      createToken({
        token: token,
        tenant_id: userDetail.tenant_id,
        roles: roles,
        name: form.getFieldValue("name"),
        expired_date: values.exprired
          ? moment(form.getFieldValue("exprired")).format("YYYY-MM-DD HH:mm:ss")
          : "",
        ratelimit_per_minute: form.getFieldValue("ratelimit_per_minute"),
      })
    );
    setOpen(false);
    form.resetFields();
    dispatch(getDomains());
  };

  function convertString(inputString) {
    // Split the input string based on underscore
    let parts = inputString.split("_");

    // Capitalize the first letter of each part
    parts = parts.map((part) => part.charAt(0).toUpperCase() + part.slice(1));

    // Join the parts with a space
    let resultString = parts.join(" ");

    return resultString;
  }

  return (
    <CustomDrawer
      title={t("tokenManagement.addNewToken")}
      placement="right"
      onClose={onClose}
      open={open}
      width={"600px"}
    >
      <Form
        name="basic"
        layout="vertical"
        style={{
          maxWidth: 600,
        }}
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
        initialValues={{
          ratelimit_per_minute: 1000,
        }}
      >
        <Form.Item
          label={t("tokenManagement.name")}
          name="name"
          rules={[
            {
              required: true,
              message: t("tokenManagement.inputName"),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Token" name="token">
          <TokenWrapper>
            <Input value={token} disabled />
            <button
              onClick={() => {
                navigator.clipboard.writeText(token);
                Notification("success", "Successfully!");
              }}
              type="button"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.39992 15.1667H4.59992C1.99325 15.1667 0.833252 14.0067 0.833252 11.4V8.59999C0.833252 5.99333 1.99325 4.83333 4.59992 4.83333H7.39992C10.0066 4.83333 11.1666 5.99333 11.1666 8.59999V11.4C11.1666 14.0067 10.0066 15.1667 7.39992 15.1667ZM4.59992 5.83333C2.53325 5.83333 1.83325 6.53333 1.83325 8.59999V11.4C1.83325 13.4667 2.53325 14.1667 4.59992 14.1667H7.39992C9.46659 14.1667 10.1666 13.4667 10.1666 11.4V8.59999C10.1666 6.53333 9.46659 5.83333 7.39992 5.83333H4.59992Z"
                  // fill="#20A2A2"
                />
                <path
                  d="M11.3999 11.1667H10.6666C10.3933 11.1667 10.1666 10.94 10.1666 10.6667V8.59999C10.1666 6.53333 9.46659 5.83333 7.39992 5.83333H5.33325C5.05992 5.83333 4.83325 5.60666 4.83325 5.33333V4.6C4.83325 1.99333 5.99325 0.833328 8.59992 0.833328H11.3999C14.0066 0.833328 15.1666 1.99333 15.1666 4.6V7.4C15.1666 10.0067 14.0066 11.1667 11.3999 11.1667ZM11.1666 10.1667H11.3999C13.4666 10.1667 14.1666 9.46666 14.1666 7.4V4.6C14.1666 2.53333 13.4666 1.83333 11.3999 1.83333H8.59992C6.53325 1.83333 5.83325 2.53333 5.83325 4.6V4.83333H7.39992C10.0066 4.83333 11.1666 5.99333 11.1666 8.59999V10.1667Z"
                  // fill="#20A2A2"
                />
              </svg>
            </button>
            <button
              type="button"
              onClick={() => {
                handleRefreshToken();
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.99992 1.83333C4.5707 1.83333 1.83325 4.59483 1.83325 8C1.83325 8.27614 1.60939 8.5 1.33325 8.5C1.05711 8.5 0.833252 8.27614 0.833252 8C0.833252 4.04516 4.01581 0.833328 7.99992 0.833328C10.3717 0.833328 12.1478 1.824 13.321 2.80272C13.6486 3.076 13.9304 3.34923 14.1666 3.60134V1.70666C14.1666 1.43052 14.3904 1.20666 14.6666 1.20666C14.9427 1.20666 15.1666 1.43052 15.1666 1.70666V5.04C15.1666 5.31614 14.9427 5.54 14.6666 5.54H11.7066C11.4304 5.54 11.2066 5.31614 11.2066 5.04C11.2066 4.76385 11.4304 4.53999 11.7066 4.53999H13.6661C13.4173 4.25159 13.0886 3.91104 12.6805 3.57061C11.632 2.69599 10.0748 1.83333 7.99992 1.83333ZM14.6666 7.5C14.9427 7.5 15.1666 7.72385 15.1666 8C15.1666 11.9561 11.9561 15.1667 7.99992 15.1667C5.98628 15.1667 4.38958 14.1532 3.32067 13.1837C3.03694 12.9263 2.78722 12.6693 2.57325 12.4303V14.2933C2.57325 14.5695 2.34939 14.7933 2.07325 14.7933C1.79711 14.7933 1.57325 14.5695 1.57325 14.2933V10.96C1.57325 10.6839 1.79711 10.46 2.07325 10.46H5.08659C5.36273 10.46 5.58659 10.6839 5.58659 10.96C5.58659 11.2361 5.36273 11.46 5.08659 11.46H3.05799C3.29851 11.7524 3.6122 12.098 3.9925 12.443C4.96693 13.3268 6.33356 14.1667 7.99992 14.1667C11.4038 14.1667 14.1666 11.4039 14.1666 8C14.1666 7.72385 14.3904 7.5 14.6666 7.5Z"
                  // fill="#20A2A2"
                />
              </svg>
            </button>
          </TokenWrapper>
        </Form.Item>
        <Form.Item
          label={t("tokenManagement.expiredDate")}
          name="exprired"
          // rules={[
          //   {
          //     required: true,
          //     message: t("tokenManagement.inputDate"),
          //   },
          // ]}
        >
          <DatePicker showTime />
        </Form.Item>

        <Form.Item
          label={t("tokenManagement.rateLimitPerMinute")}
          name="ratelimit_per_minute"
          rules={[
            {
              required: true,
              message: t("tokenManagement.inputRate"),
            },
          ]}
        >
          <InputNumber />
        </Form.Item>

        <TableWrapper>
          <table className="table" border={1}>
            <thead>
              <tr>
                <th>
                  {" "}
                  {/* <Checkbox />  */}
                  <span className="name">Modules</span>
                </th>
                {domains?.permissions?.map((item, indx) => {
                  return (
                    <th>
                      {" "}
                      {/* <Checkbox /> */}
                      <span className="name">{convertString(item)}</span>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {domains?.domain?.map((module, idx) => {
                return (
                  <tr>
                    <td>
                      {/* <Checkbox /> */}
                      <span className="name">{convertString(module)}</span>
                    </td>
                    {domains?.permissions.map((item, indx) => {
                      return (
                        <td>
                          <Checkbox
                            checked={
                              roles &&
                              roles[idx] &&
                              roles[idx]["permissions"]?.findIndex(
                                (ele) => ele === item
                              ) < 0
                                ? false
                                : true
                            }
                            onChange={(e) => {
                              let tempRoles = [...roles];

                              const newObject = _.find(tempRoles, {
                                domain: module,
                              });
                              if (
                                newObject.permissions.findIndex(
                                  (ele) => ele === item
                                ) < 0
                              ) {
                                newObject.permissions.push(item);
                              } else {
                                _.pull(newObject.permissions, item);
                              }

                              setRoles(tempRoles);
                            }}
                          />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </TableWrapper>
        <ButtonWrapper>
          <Button
            className="cancel"
            onClick={() => {
              setOpen(false);
            }}
          >
            {t("common.cancel")}
          </Button>
          <Button className="save" htmlType="submit">
            {t("common.save")}
          </Button>
        </ButtonWrapper>
      </Form>
    </CustomDrawer>
  );
};

export default DrawerAddToken;

const TokenWrapper = styled.div`
  display: flex;
  button {
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.main};
    border-radius: 6px;
    margin-left: 8px;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      fill: ${(props) => props.theme.main}!important;
      color: ${(props) => props.theme.main}!important;
    }
  }
`;

const CustomDrawer = styled(Drawer)`
  .ant-input {
    border-radius: 6px;
    border: 1px solid #919eab 22%;
  }

  .ant-input-number {
    border-radius: 6px;
    border: 1px solid #919eab 22%;
    width: 100%;
  }

  .ant-picker {
    border-radius: 6px;
    border: 1px solid #919eab 22%;
    width: 100%;
  }
  .ant-form-item-label {
    label {
      font-family: var(--roboto-700);
      font-size: 16px;
    }
  }
  .ant-form-item {
    margin-bottom: 16px;
    color: #212b36;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow: auto;
  table {
    width: max-content;
    border-collapse: separate;
    border: none;
    th {
      font-size: 16px;
      font-family: var(--Roboto-400);
      padding: 8px 16px;
      background-color: #ededed;
      border: none;
    }
    tbody {
      td {
        /* text-align: center; */
        border: none;
        padding-left: 16px;
        .ant-checkbox-input {
          margin-right: 8px;
        }
      }
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
  .cancel {
    font-size: 16px;
    color: ${(props) => props.theme.main};
    border: 1px solid ${(props) => props.theme.main};
    border-radius: 6px;
    padding: 5px 12px 5px 12px;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .save {
    font-size: 16px;
    color: white;
    border: 1px solid ${(props) => props.theme.main};
    border-radius: 6px;
    padding: 5px 12px 5px 12px;
    background-color: ${(props) => props.theme.main};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 12px;
    cursor: pointer;
  }
`;
